import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Instagram, Lock } from 'lucide-react';
import { companyInfo } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <Link to="/" className="inline-block mb-6">
              <img 
                src="/logo-luvcorp.png" 
                alt="LUVCORP Soluções Prediais" 
                className="h-14 w-auto hover:scale-105 transition-transform"
              />
            </Link>
            <p className="text-sm text-gray-400 mb-4">
              Especialistas em reforma e manutenção predial com foco em reforma de fachadas. Mais de 5 anos de experiência no Rio de Janeiro.
            </p>
            <div className="flex items-center space-x-3 p-3 bg-gray-800 rounded-lg">
              <div className="text-[#F47A20]">
                <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2L2 7v10c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-10-5zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
                </svg>
              </div>
              <div>
                <div className="text-xs text-gray-400">CREA-RJ</div>
                <div className="text-sm font-semibold text-white">2025201541</div>
                <div className="text-xs text-gray-400">Eng. Matheus de Souza</div>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">Links Rápidos</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm hover:text-[#F47A20] transition-colors">
                  Início
                </Link>
              </li>
              <li>
                <Link to="/quem-somos" className="text-sm hover:text-[#F47A20] transition-colors">
                  Quem Somos
                </Link>
              </li>
              <li>
                <Link to="/servicos" className="text-sm hover:text-[#F47A20] transition-colors">
                  Serviços
                </Link>
              </li>
              <li>
                <Link to="/reforma-fachada" className="text-sm hover:text-[#F47A20] transition-colors">
                  Reforma de Fachada
                </Link>
              </li>
              <li>
                <Link to="/projetos" className="text-sm hover:text-[#F47A20] transition-colors">
                  Projetos
                </Link>
              </li>
              <li>
                <Link to="/blog" className="text-sm hover:text-[#F47A20] transition-colors">
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">Serviços</h3>
            <ul className="space-y-3">
              <li className="text-sm">Reforma de Fachada</li>
              <li className="text-sm">Manutenção Predial</li>
              <li className="text-sm">Impermeabilização</li>
              <li className="text-sm">Reformas Completas</li>
              <li className="text-sm">Pintura Predial</li>
              <li className="text-sm">Reparos Estruturais</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-6">Contato</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-[#F47A20] mt-1 flex-shrink-0" />
                <span className="text-sm">{companyInfo.address}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={18} className="text-[#F47A20] flex-shrink-0" />
                <a href={`tel:${companyInfo.phone.replace(/\s/g, '')}`} className="text-sm hover:text-[#F47A20] transition-colors">
                  {companyInfo.phone}
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={18} className="text-[#F47A20] flex-shrink-0" />
                <a href={`mailto:${companyInfo.email}`} className="text-sm hover:text-[#F47A20] transition-colors break-all">
                  {companyInfo.email}
                </a>
              </li>
              <li className="flex items-center space-x-3">
                <Instagram size={18} className="text-[#F47A20] flex-shrink-0" />
                <a href={companyInfo.instagramUrl} target="_blank" rel="noopener noreferrer" className="text-sm hover:text-[#F47A20] transition-colors">
                  {companyInfo.instagram}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container-custom py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © {currentYear} LUVCORP Soluções Prediais. Todos os direitos reservados.
            </p>
            <div className="flex items-center space-x-6">
              <Link to="#" className="text-sm text-gray-400 hover:text-[#F47A20] transition-colors">
                Política de Privacidade
              </Link>
              <Link to="#" className="text-sm text-gray-400 hover:text-[#F47A20] transition-colors">
                Termos de Uso
              </Link>
              <Link 
                to="/admin/login" 
                className="flex items-center space-x-1 text-sm text-gray-500 hover:text-[#F47A20] transition-colors"
                data-testid="admin-access-link"
              >
                <Lock size={14} />
                <span>Área Administrativa</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;